import logo from './logo.svg';
import './App.css';
import NavBar from './Components/NavBar';
import { Navigate, Route } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import { BrowserRouter, Redirect } from 'react-router-dom';
import Home from './Components/Home';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AboutUs from './Pages/AboutUs';
import ResearchFocus from './Pages/ResearchFocus';
import ContactUs from './Pages/ContactUs';
import People from './Pages/People';
import { Box, Container, Divider, Toolbar } from '@mui/material';
import Projects from './Pages/Projects';
import Publications from './Pages/Publications';
import Infrastructure from './Pages/Infrastructure';
import News from './Pages/News';

function App() {
  const theme = createTheme({
    components: {
      // Name of the component
      MuiCard: {
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            borderRadius: '24px',
            backgroundColor: 'rgba(255, 255, 255, 0.8);',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          elevation: 2,
          root: {
            padding: 2,
            borderRadius: '20px'
          }
        }
      }
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <BrowserRouter>
          {/* <NavBar /> */}

          <Routes>
            <Route path='/' element={<NavBar />}>
              <Route index element={<Home />} />
              <Route path='/about' element={<AboutUs />} />
              <Route path='/research-focus' element={<ResearchFocus />} />
              <Route path='/projects' element={<Projects />} />
              <Route path='/publications' element={<Publications />} />
              <Route path='/people' element={<People />} />
              <Route path='/contact' element={<ContactUs />} />
              <Route path='/infrastructure' element={<Infrastructure />} />
              <Route path='/news' element={<News />} />
              <Route path='*' element={<Navigate to="/" />} />

            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider >
  );
}

export default App;
